import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export class WizardPanel extends React.Component {
    constructor(props) {
        super(props);
    }
}
export class Wizard extends React.Component {
    constructor(props) {
        super(props);
        this.changePanel = (panelKey) => {
            const { currentPanel, panelStack } = this.state;
            if (this.props.onPanelChange) {
                this.props.onPanelChange(panelKey, currentPanel);
            }
            const newStack = [...panelStack];
            newStack.push(currentPanel);
            this.setState({ currentPanel: panelKey, panelStack: newStack });
        };
        this.goBack = () => {
            const { currentPanel, panelStack } = this.state;
            if (panelStack.length === 0) {
                throw Error("Can't go back any further.");
            }
            const newStack = [...panelStack];
            const lastPanel = newStack.pop();
            if (this.props.onPanelChange) {
                this.props.onPanelChange(lastPanel, currentPanel);
            }
            this.setState({ currentPanel: lastPanel, panelStack: newStack });
        };
        this.state = {
            panelStack: [],
            currentPanel: props.firstPanel
        };
    }
    render() {
        const panelComponents = this.props.panelComponents;
        const { currentPanel } = this.state;
        // todo: thomas -- there appears to be a bug with TypeScript where
        // indexing into the record doesn't correctly type Panel, below
        // ...hence the `as any as...` cast
        const Panel = panelComponents[currentPanel];
        const CurrentPanel = _jsx("div", { children: _jsx(Panel, Object.assign({}, this.props, { changePanel: this.changePanel, goBack: this.goBack })) });
        return _jsx("div", { children: CurrentPanel });
    }
}
